export default __webpack_public_path__ + "static/media/logo.bcab2398.webp";